// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { checkoutReviewAndSubmitHeaderStyles } from "@monsma/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.container = {
    css: css`
        border-bottom: 1px solid ${getColor("common.ui12")};
        margin: 20px 0;
        ${screen("lt", "md")} {
            border-bottom-color: transparent;
            margin-bottom: 10px;
        }
    `,
};
checkoutReviewAndSubmitHeaderStyles.headingText = {
    variant: "h2",
    css: css`
        ${screen("lt", "md")} {
            margin-bottom: 0;
        }
    `,
};

checkoutReviewAndSubmitHeaderStyles.gridItem = { width: [12, 12, 4, 6, 6] };

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: none;
    `,
};

checkoutReviewAndSubmitHeaderStyles.xStyle = {
    stepper: {
        width: [12, 12, 8, 6, 6],
        css: css`
            display: flex;
            justify-content: end;
            align-items: center;
            ${screen("lte", "md")} {
                justify-content: center;
            }
            ${screen("lt", "sm")} {
                border-top: 1px solid ${getColor("common.ui12")};
            }
        `,
    },
};
